import React from 'react';

const EvaluationScore = () => {
  return <div>EvaluationScore</div>;
};
export default EvaluationScore;
